export default {
    state: () => ({
        data: { }
    }),
    mutations: {
        ['cabinet/setState'](state, payload) {
            state.data = {...payload,}
        },
    },
    actions: {
        async ['cabinet/updateData']({commit}) {
            try {
                commit('global/loaderStart');
                const { status, data } = await axios.get(location.pathname + '?api=y');

                if (status === 200) {
                    commit('cabinet/setState', data);
                }

                commit('global/loaderStop');
            } catch (err) {
                console.error(err);
            }
        },
        async ['cabinet/loadMenuSection']({commit}, url) {
            commit('global/loaderStart');
            try {
                const {status, data} = await axios.post(url + '?api=y')
                // commit('global/loaderStart');
                if (status !== 200) {
                    throw `bad request response status: ${status}, url ${url}?api=y`;
                }

                if (status === 200) {
                    history.pushState(null, null, url);
                    commit('cabinet/setState', data);
                    commit('global/loaderStop');

                    if (typeof data === 'string') {
                        window.location.reload();
                    }
                }
            } catch (err) {
                console.error(err);
            }
        },
        async ['cabinet/checkPhone']({commit}, payload) {
            try{
                const {status, data} = await axios.post(payload.url, payload.formData);
                if (status === 200) {
                    commit('cabinet/setState', data);
                    if(data.setPhoneResult && data.setPhoneResult.ok) {
                        location.reload();
                    }
                }
            } catch(err){
                console.error(err)
            }
        },
        async ['cabinet/getPage']({commit}, payload) {
            commit('global/loaderStart');
            try{
                const response = await axios.get(payload.path, {params: {
                    api: 'y'
                }});
                if ( response.status === 200) {
                    commit('cabinet/setState', response.data);
                    commit('global/loaderStop');
                }
            } catch(err){
                console.error(err)
            }
        },
        async ['cabinet/loadPageData']({ commit, dispatch }, url) {
            try {
                commit('global/loaderStart');
                const { status, data } = await axios.get(url, { params: { api: 'y' } });

                if (status !== 200) throw `bad request response status: ${ status }`;

                commit('cabinet/setState', data);
                dispatch('footerMiniBanner/refresh', url);
                commit('global/loaderStop');
            } catch (err) {
                console.error(err);
            }
        },
        async ['cabinet/getCreateClubCard'] ({ state, commit }, formData) {
            try{
                const { path, action } = state.data.routes.getCreateClubCard;
                formData.set('action', action);
                const { status } = await axios.post( path, formData )

                if (status !== 200) throw `bad request response status: ${ status }`;

            } catch (err) {
                console.error(err)
            }
        },
    },
}
